import {useStore} from "vuex";
import {computed} from "vue";
import router from "@/router";

export default function useLogin() {
  const store = useStore()

  const login = (data) => {
    return store.dispatch('user/login', data)
  }

  const logout = () => {
    store.dispatch('user/logout')
      .then(() => router.push('/login'))
      .catch(reason => Promise.reject(reason))
  }

  return {
    login,
    logout,
    isAuthorized: computed(() => store.state.isAuthorized)
  }
}
